<div
	class="mt-5"
	[innerHTML]="content | ngSafeHTML"
	ngRouterLinkTransformer
></div>
